<template>
  <div class="container">
    <div class="new-request-container">
      <h4>Enviar uma solicitação</h4>

      <div class="web-to-case">
        <!--web-to-case inicio -->
        <!--  ----------------------------------------------------------------------  -->
        <!--  NOTA: Adicione o seguinte elemento <META> à sua página <HEAD>.  Se      -->
        <!--  necessário, modifique o parâmetro charset para especificar o conjunto   -->
        <!--  de caracteres de sua página HTML.                                       -->
        <!--  ----------------------------------------------------------------------  -->

        <!--  ----------------------------------------------------------------------  -->
        <!--  NOTA: Adicione o elemento <FORM> a seguir à sua página.                 -->
        <!--  ----------------------------------------------------------------------  -->

        <form action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8" method="POST"
          class="request-form" style="width: 100%" @submit="checkForm">
          <input type="hidden" name="orgid" value="00D4P000000iyUc" />
          <input type="hidden" name="retURL" :value="`http://www.${nomeSite}.com.br/ajuda`" />

          <!--  ----------------------------------------------------------------------  -->
          <!--  NOTA: Estes campos são elementos de depuração opcionais. Remova o       -->
          <!--  comentário dessas linhas se quiser testar no modo de depuração.         -->
          <!--  <input type="hidden" name="debug" value=1>                              -->
          <!--  <input type="hidden" name="debugEmail" value="marcus.salome@restoque.com.br">                                 -->
          <!--  ----------------------------------------------------------------------  -->
          <div class="form-field-wtc">
            <label class="required" for="00N4P00000GYD4B">Nome Completo</label>
            <input class="required" id="00N4P00000GYD4B" maxlength="100" name="00N4P00000GYD4B" size="20" type="text"
              v-model="nome" />
          </div>
          <div class="form-field-wtc">
            <label class="required" for="email">Email</label>
            <input class="required" id="email" maxlength="100" name="email" size="20" type="text" v-model="email" />
          </div>
          <div class="form-field-wtc">
            <label class="required" for="00N4P00000GYD3q">CPF</label>
            <input class="required" id="00N4P00000GYD3q" maxlength="100" name="00N4P00000GYD3q" size="20" type="text"
              v-model="cpf" />
          </div>
          <div class="form-field-wtc">
            <label class="required" for="phone">Telefone</label>
            <input class="required" id="phone" maxlength="100" name="phone" size="20" type="text" v-model="telefone" />
          </div>
          <div class="form-field-wtc">
            <label class="required" for="00N4P00000GYD3r">Solicitação</label>
            <select class="required" id="00N4P00000GYD3r" name="00N4P00000GYD3r" title="Categoria" v-model="solicitacao"
              @change="changeSol($event)">
              <option v-for="(sol, index) in options" :key="index" :value="sol.nome">
                {{ sol.nome }}
              </option>
            </select>
          </div>
          <div class="form-field-wtc" v-if="solicitacaoIndex > -1 &&
            options[solicitacaoIndex].hasOwnProperty('motivos')
            ">
            <label class="required" for="00N4P00000GYD4A">Motivo do Contato</label>
            <select class="required" id="00N4P00000GYD4A" name="00N4P00000GYD4A" title="Motivo do Contato"
              v-model="motivo" @change="changeMot($event)">
              <option v-for="(mot, index) in options[solicitacaoIndex].motivos" :key="index" :value="mot.nome">
                {{ mot.nome }}
              </option>
            </select>
          </div>
          <div class="form-field-wtc" v-if="motivoIndex > -1 &&
            options[solicitacaoIndex].motivos[motivoIndex].hasOwnProperty(
              'submotivos'
            )
            ">
            <label class="required" for="00N4P00000GYD4G">Sub-Motivo</label>
            <select class="required" id="00N4P00000GYD4G" name="00N4P00000GYD4G" title="Motivo do Contato"
              v-model="submotivo">
              <option v-for="(sub, index) in options[solicitacaoIndex].motivos[
                motivoIndex
              ].submotivos" :key="index" :value="sub.nome">
                {{ sub.nome }}
              </option>
            </select>
          </div>
          <div class="form-field-wtc">
            <label class="required" for="subject">Assunto</label>
            <input class="required" id="subject" maxlength="100" name="subject" size="20" type="text" v-model="assunto"
              disabled />
          </div>
          <div class="form-field-wtc">
            <label for="00N4P00000GYD4D">Número do Pedido:</label>
            <input id="00N4P00000GYD4D" maxlength="100" name="00N4P00000GYD4D" size="20" type="text"
              v-model="numPedido" />
          </div>
          <div class="form-field-wtc select">
            <label for="00N4P00000GYD4E">Quantidade de Produto:</label>
            <select id="00N4P00000GYD4E" name="00N4P00000GYD4E" title="Quantidade de Produto" v-model="qttProd">
              <option value>-- Nenhum --</option>
              <option v-for="(i, index) in 5" :value="i" :key="index">
                {{ i }}
              </option>
            </select>
            <br />
          </div>

          <div class="form-field-wtc" v-for="input in prodInputs.slice(0, qttProd)" :key="input.id">
            <label :for="input.Id">{{ input.Name }}</label>
            <input :id="input.Id" maxlength="255" :name="input.Id" type="text" />
          </div>

          <div class="form-field-wtc">
            <label class="required" for="description">Descrição</label>
            <textarea rows="4" cols="50" class="required" id="description" maxlength="5000" name="description"
              type="textarea" v-model="descricao" />
          </div>
          <input type="hidden" name="00N4P00000GSAvy" id="00N4P00000GSAvy" value="true" />
          <select hidden="true" id="00N4P00000GYD48" name="00N4P00000GYD48" title="Marca">
            <option :value="nomeMarca" selected>{{ nomeMarca }}</option>
          </select><br />
          <input type="hidden" title="Grupo__c" id="00N4P00000GYD44" name="00N4P00000GYD44"
            value="Central de Relacionamento" />
          <input type="submit" class="submitBtn" name="submit" />
        </form>
        <!--web-to-case fim -->
      </div>
    </div>
  </div>
</template>

<script>
import { options } from "@/assets/data/options.json";
export default {
  name: "Form",
  components: {},
  data: function () {
    return {
      nome: this.urlParsed(window.location.search)["nome"],
      email: this.urlParsed(window.location.search)["email"],
      cpf: this.urlParsed(window.location.search)["cpf"],
      telefone: this.urlParsed(window.location.search)["phone"],
      options,
      solicitacao: this.urlParsed(window.location.search)["solicitacao"],
      motivo: this.urlParsed(window.location.search)["motivo"],
      submotivo: this.urlParsed(window.location.search)["assunto"],
      numPedido: this.urlParsed(window.location.search)["orderNumber"],
      descricao: this.urlParsed(window.location.search)["descricao"],
      validacao: "",
      qttProd: "",
      prodInputs: [
        {
          Id: "00N4P00000GYD3t",
          Name: "Código do Produto 1",
        },
        {
          Id: "00N4P00000GYD3u",
          Name: "Código do Produto 2",
        },
        {
          Id: "00N4P00000GYD3v",
          Name: "Código do Produto 3",
        },
        {
          Id: "00N4P00000GYD3w",
          Name: "Código do Produto 4",
        },
        {
          Id: "00N4P00000GYD3x",
          Name: "Código do Produto 5",
        },
      ],
      nomeSite: window.location.hostname.split(".")[1] || "bobo",
      nomeMarca: "",
      solicitacaoIndex: -1,
      motivoIndex: -1,
    };
  },
  methods: {
    urlParsed: function (search) {
      if (search) {
        let data = search.replace("?", "");
        let urlParsed = JSON.parse('{"' + data.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
        return urlParsed
      } else {
        return ""
      }
    },
    checkForm(e) {
      // campos para validar
      let inputs = [...e.target.elements];
      let inputsRequired = inputs.filter((element) => {
        return element.classList.value.includes("required");
      });
      // inputs para corrigir
      let inputsFixed = inputsRequired.filter((element) => {
        return element.classList.value.includes("fix") && element.value != "";
      });

      inputsFixed.forEach((inputFixed) => {
        inputFixed.classList.remove("fix");
        inputFixed.previousElementSibling.remove();
      });

      // checando valor dos inputs
      inputsRequired.forEach((input) => {
        if (input.value == "") {
          input.classList.add("invalid");
        } else {
          input.classList.remove("invalid");
        }
      });
      // armazenando inputs requiridos e invalidos
      let inputsRequiredAndInvalid = [...inputsRequired].filter(
        (inputRequired) => {
          return inputRequired.classList.value.includes("invalid");
        }
      );
      // tudo validado
      if (!inputsRequiredAndInvalid.length) {
        return true;
        // invalido
      } else {
        inputsRequiredAndInvalid.forEach((element) => {
          if (!element.classList.value.includes("fix")) {
            element.insertAdjacentHTML(
              "beforebegin",
              '<div class="invalido">Campo inválido</div>'
            );
          }
          element.classList.add("fix");
        });
      }
      e.preventDefault();
    },
    changeSol(event) {
      this.solicitacaoIndex = options.findIndex((solicitacao) => {
        return solicitacao.nome === event.target.value;
      });
      this.motivo = "";
      this.submotivo = "";
    },
    changeMot(event) {
      this.motivoIndex = options[this.solicitacaoIndex].motivos.findIndex(
        (motivo) => {
          return motivo.nome === event.target.value;
        }
      );
      this.submotivo = "";
    },
    setMarca() {
      let SITE_NAME = {
        johnjohndenim: "John John",
        bobo: "BoBô",
        lelis: "Le Lis Blanc",
        dudalina: "Dudalina",
        rosacha: "Rosa Chá",
        estoque: "Estoque",
      };

      this.nomeMarca =
        SITE_NAME[window.location.hostname.split(".")[1] || "bobo"];
    },
  },
  computed: {
    assunto: function () {
      return `${this.motivo ? this.motivo : ""} ${this.submotivo ? "- " + this.submotivo : ""
        }`;
    }
  },
  created() {
    this.setMarca();
  },
};
</script>
<style lang="scss">
.new-request-container {
  width: 100%;
  margin: 0 auto;
  padding: 30px 50px 0 50px;

  & h4 {
    font-weight: 700;
    color: rgba(0, 0, 0, 1);
    font-size: 17px;
    text-transform: uppercase;
    margin-bottom: 50px;
  }
}

.web-to-case {
  margin: 0 auto;
}

.form-field-wtc label {
  font-size: 12px;
  color: rgba(0, 0, 0, 1);
  display: block;
}

.form-field-wtc>input,
.form-field-wtc>textarea,
.form-field-wtc>select {
  height: 30px;
  outline: none;
  vertical-align: top;
  background-color: #fff;
  border: 1px solid #808080;
  width: 80%;
  margin-bottom: 20px;
  padding: 0 10px;
}

.form-field-wtc>textarea {
  height: auto;
}

.form-field-wtc .required:after {
  content: "*";
  color: red;
}

.submitBtn {
  min-width: 205px;
  font-weight: 700;
  color: #ffffff;
  font-size: 13px;
  border: none;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 1);
  text-transform: uppercase;
  padding: 10px 15px;
  transition: background 300ms ease;
  font-family: "Roboto";

  &:hover,
  :focus,
  :active {
    background-color: #333;
    cursor: pointer;
  }
}
</style>